import { lazy } from 'react';

const RETRY_KEY = 'titanium_chunk_retry_timestamp';

// Listen to Vite chunk preload errors globally
if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', () => {
    const lastReload = Number(sessionStorage.getItem(RETRY_KEY) || '0');
    const now = Date.now();
    if (now - lastReload > 10000) {
      sessionStorage.setItem(RETRY_KEY, String(now));
      window.location.reload();
    }
  });
}

/**
 * Robust lazy-loader that catches dynamic import failures (such as stale hashed
 * chunks after rebuilds or dev server restarts), retries once immediately, and
 * if still failing, performs a controlled page reload guarded by sessionStorage.
 */
export function lazyWithRetry(componentImport) {
  return lazy(async () => {
    try {
      return await componentImport();
    } catch (firstError) {
      // First retry attempt
      try {
        return await componentImport();
      } catch (secondError) {
        const lastReload = Number(sessionStorage.getItem(RETRY_KEY) || '0');
        const now = Date.now();
        if (now - lastReload > 10000) {
          sessionStorage.setItem(RETRY_KEY, String(now));
          window.location.reload();
          // Keep suspense pending while the browser navigates
          return new Promise(() => {});
        }
        throw secondError;
      }
    }
  });
}

export default lazyWithRetry;
